import React from 'react';
import PropTypes from 'prop-types';
import { AlertHeader, AlertTitle, AlertContent, AlertFooter, AlertButtons } from 'assets/styles/sharedStyles';
import { getItemPrice } from 'selectors/browse';
import { getComboUpsellMessage } from 'selectors/root';
import { List } from 'immutable';
import { connect } from 'react-redux';
import BackIcon from 'components/Icons/BackIcon';
import ActionButton from '../../../ActionButton';
import { StyledBackButton } from '../../styles';
import OrderComboUpsells from '../../../OrderReview/OrderComboUpsells';

const ComboUpsellAlert = ({
  menuTypeId,
  sectionProducts,
  onAccept,
  onDecline,
  getItemPrice,
  serviceId,
  comboUpsellMessage,
}) => (
  <>
    <AlertHeader>
      <StyledBackButton onClick={onDecline}>
        <BackIcon />
      </StyledBackButton>
      <AlertTitle>{comboUpsellMessage || 'You may also like'}</AlertTitle>
    </AlertHeader>
    <AlertContent>
      <OrderComboUpsells
        comboUpsellsList={sectionProducts}
        menuTypeId={menuTypeId}
        serviceId={serviceId}
        onAccept={onAccept}
        getItemPrice={getItemPrice}
        hideTitle={true}
      />
    </AlertContent>
    <AlertFooter>
      <AlertButtons>
        <ActionButton primaryButton={true} label="No Thanks" onClick={onDecline} />
      </AlertButtons>
    </AlertFooter>
  </>
);

ComboUpsellAlert.propTypes = {
  menuTypeId: PropTypes.number.isRequired,
  sectionProducts: PropTypes.instanceOf(List).isRequired,
  serviceId: PropTypes.string.isRequired,
  comboUpsellMessage: PropTypes.string,
  onAccept: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
  getItemPrice: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  getItemPrice: (price, taxCategories) => getItemPrice(state, price, taxCategories),
  comboUpsellMessage: getComboUpsellMessage(state, ownProps.serviceId),
});

export default connect(mapStateToProps)(ComboUpsellAlert);
